import { Box, BoxProps, ColorOptions, ModBox, TextNew, TextNewProps } from '@jfs/ui-new'
import React from 'react'
import { LoaderOrText } from './LoaderOrText'

interface ModifiedActionButtonProps {
  props?: any
  loaderState?: any
  onOutlineButtonPress?: () => void
  coloredButtonText?: string
  isValid?: boolean
  onColoredButtonPress: () => void
  outlineButtonTitle?: string
  isOutlineButtonVisible: boolean
  isColoredButtonVisible: boolean
  hide?: boolean
}

export const DualActionButtonComp = React.memo(
  ({
    onOutlineButtonPress,
    isOutlineButtonVisible = false,
    loaderState,
    outlineButtonTitle = 'Upload',
    isValid = false,
    coloredButtonText = 'Done',
    isColoredButtonVisible = true,
    hide = false,
    onColoredButtonPress,
  }: ModifiedActionButtonProps) => {
    const handleSubmit = () => {
      onColoredButtonPress && onColoredButtonPress()
    }
    if (hide) {
      return null
    }
    return (
      <Box {...style.flexRowView}>
        <ModBox
          {...style.outlinedBox}
          show={isOutlineButtonVisible}
          onPress={() => onOutlineButtonPress && onOutlineButtonPress()}>
          <TextNew title={outlineButtonTitle} {...style.outlineButtonText} />
        </ModBox>
        <ModBox
          testID={'ActionButton'}
          show={isColoredButtonVisible}
          {...style.buttonBgView}
          opacity={!isValid ? 0.5 : 1}
          disabled={!isValid}
          onPress={handleSubmit}>
          <LoaderOrText state={loaderState} text={coloredButtonText} />
        </ModBox>
      </Box>
    )
  },
)

const shadow = {
  shadowColor: 'GREY_MATTE' as ColorOptions,
  shadowOffset: {
    width: 0,
    height: 2,
  },
  shadowOpacity: 0.5,
  shadowRadius: 5,
  elevation: 2,
}

const style = {
  buttonBgView: {
    alignItems: 'center',
    justifyContent: 'center',
    pv: 7,
    borderRadius: 8,
    backgroundColor: 'PRIMARY',
    ph: 25,
    underlayColor: 'PRIMARY',
    marginLeft: 20,
    ...shadow,
  } as BoxProps,
  flexRowView: {
    borderTopWidth: 1,
    borderTopColor: 'DISABLED_GREY',
    pv: 16,
    justifyContent: 'flex-end',
    pr: 20,
    flexDirection: 'row',
    bg: 'WHITE',
  } as BoxProps,
  outlinedBox: {
    borderWidth: 1.5,
    borderColor: 'PRIMARY',
    pv: 7,
    ph: 25,
    borderRadius: 8,
    justify: 'center',
    ...shadow,
  } as BoxProps,
  outlineButtonText: {
    fontSize: 14,
    fontFamily: 'jiotype-medium',
    color: 'PRIMARY',
    lineHeight: 20,
  } as TextNewProps,
}
